import { useEffect, useState } from "react";
import { Share2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { api, apiError } from "@/lib/api";
import { RideCard } from "@/components/fleet/RideCard";

export const ShareRideDialog = ({ code, refreshKey, onClose, onBook, onUnlock }) => {
  const [ride, setRide] = useState(null);
  const [error, setError] = useState("");

  useEffect(() => {
    if (code) {
      api.get(`/share/${code}`).then((r) => { setRide(r.data); setError(""); }).catch((e) => setError(apiError(e, "Link corsa non valido")));
    }
  }, [code, refreshKey]);

  const booked = ride?.status === "booked" && !ride.booked_by_me;

  return (
    <Dialog open={!!code} onOpenChange={(o) => !o && onClose()}>
      <DialogContent data-testid="share-ride-dialog" className="ff-glass-panel sm:max-w-md max-h-[92vh] overflow-y-auto rounded-2xl p-5 sm:p-7">
        <DialogHeader className="text-left">
          <DialogTitle className="ff-display text-2xl font-extrabold flex items-center gap-2"><Share2 size={22} className="text-[#10B981]" /> Corsa passata da un collega</DialogTitle>
          <DialogDescription className="text-[#94A3B8] text-sm">
            {ride?.locked ? "Anteprima sfocata: accedi o registrati per vedere la tratta e bloccarla." : "Blocca la corsa con pagamento in escrow."}
          </DialogDescription>
        </DialogHeader>
        {error && <p data-testid="share-ride-error" className="text-red-400 text-sm">{error}</p>}
        {booked && <p data-testid="share-ride-booked" className="text-amber-400 text-sm font-semibold">Questa corsa è già stata bloccata da un altro collega.</p>}
        {ride && !booked && <RideCard ride={ride} hideShare onBook={onBook} onUnlock={onUnlock} />}
      </DialogContent>
    </Dialog>
  );
};
